
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"27","viewBox":"0 0 25 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#47AEA6"}},[_c('path',{attrs:{"d":"M16.254 3.424a1.417 1.417 0 011.922-.57c3.929 2.133 6.641 6.295 6.641 11.046A12.386 12.386 0 0112.4 26.317 12.386 12.386 0 01-.017 13.9 12.35 12.35 0 016.652 2.94a1.417 1.417 0 111.296 2.52 9.515 9.515 0 00-5.13 8.44 9.551 9.551 0 009.582 9.583 9.551 9.551 0 009.583-9.583c0-3.649-2.088-6.887-5.16-8.554a1.417 1.417 0 01-.569-1.922z"}}),_c('path',{attrs:{"d":"M12.4-.017c.783 0 1.417.634 1.417 1.417v12.5a1.417 1.417 0 01-2.834 0V1.4c0-.783.634-1.417 1.417-1.417z"}})])])
          )
        }
      }
    